module.exports = __webpack_public_path__ + "img/3.3dc207d8.svg";